import React from "react";

const Fond = () => {
  return (
    <div className="fondsite">

      <div className="fondsitetableau">      
      <div className="fondcolonne">6sz644g7geg4zer47786ht4gs11</div>
      <div className="fondcolonne">74q4t4gg7gergh8r664844sfd4df</div>
      <div className="fondcolonne">664874g7geg4e8r44e4q4t4gs4h</div>
      <div className="fondcolonne">4d5gfdf54gdfg46zergfgq4t4gs</div>
      <div className="fondcolonne">sgsg5aypm7geg4e8r4e4mvns39s</div>
      <div className="fondcolonne">6sz644g7geg4zer47786ht4g45p</div>
      <div className="fondcolonne">74q4t4gg7gergh8r664844sfd4h</div>
        <div className="fondcolonne">s1p643d1f75sf47qdfg5a4df5ds</div>
        <div className="fondcolonne">gd5rr56e4g13s9mh1337yteea23</div>
        <div className="fondcolonne">lz<span className="animfond">S</span>1aAfht<span className="animfond2">FRONT/BACK</span>h2gr14sa</div>
        <div className="fondcolonne">18<span className="animfond">P</span>graa<span className="animfond3">S</span>36N8fse2fsfsf54a<span className="animfond">R</span>4f</div>
        <div className="fondcolonne">z6<span className="animfond">O</span>f65e<span className="animfond3">A</span>f45rg45e4f65e654<span className="animfond">E</span>46</div>
        <div className="fondcolonne">6f<span className="animfond">R</span>5gr4<span className="animfond3">N</span>f61gqfg4g<span className="animfond3">PHP</span>g445<span className="animfond">A</span>e8</div>
        <div className="fondcolonne">tr<span className="animfond">T</span>uo5j<span className="animfond3">T</span>ju89tk4li4874hgj<span className="animfond">C</span>64</div>
        <div className="fondcolonne">rg4gr54<span className="animfond3">É</span>4ht4sh4j6k54t5s8<span className="animfond">T</span>q9</div>
        <div className="fondcolonne">664874g7geg4e8r44e4q4t4gs4h</div>
        <div className="fondcolonne">g4<span className="animfond2">NUTRITION</span>4h4st4h64<span className="animfond3">JS</span>4thss</div>
        <div className="fondcolonne">wb1nvn16wg4787b899qr4h9th7Q</div>
        <div className="fondcolonne">4d5gfdf54gdfg46zergfgq4t4gs</div>
      <div className="fondcolonne">sgsg5aypm7geg4e8r4e4mvns39s</div>
      <div className="fondcolonne">6sz644g7geg4zer47786ht4gs12</div>
      <div className="fondcolonne">74q4t4gg7gergh8r664844sfd4h</div>
      <div className="fondcolonne">664874g7geg4e8r4ze4q4t4gszh</div>
      <div className="fondcolonne">74q4t4gg7gergh8r664844sfdgd</div>
      <div className="fondcolonne">6sz644g7geg4zer47786ht4gs9h</div>
      </div>
    </div>
  );
};

export default Fond;
